import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import SkillsModal from "../Common_profile_details_modals/SkillsModal/SkillsModal";
import "./SkillsCard.css";

function SkillsCard() {
  const [showModal, setShowModal] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const skills = [
    "Html5",
    "Css3",
    "React",
    "Javascript",
    "Bootstrap",
    "Frontend Development",
    "Responsive Design & Optimization",
    "Mobile-first design",
    "cross-browser compatibility",
    "Software Development",
    "Agile Methodology",
    "Version Control",
    "Git",
    "REST API",
    "Redux",
    "Material UI",
    "Tailwind CSS",
    "React Router",
    "Performance Optimization",
    "Responsive UI",
    "Webpack",
    "Vite",
    "Figma"
  ];

  const visibleSkills = expanded ? skills : skills.slice(0, 9);

  return (
    <>
      <Card className="profile-card-pattern skills-card SkillsCard">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <h3 className="profile-card-pattern__title">
              Skills
            </h3>

            <Button
              variant="link"
              className="profile-card-pattern__btn-edit"
              onClick={() => setShowModal(true)}
            >
              <span className="summary-card__edit-icon">
                ✏️
              </span>
            </Button>
          </div>

          <div className="skills-card__list">
            {visibleSkills.map((skill, index) => (
              <span
                key={index}
                className="skills-card__chip"
              >
                {skill}
              </span>
            ))}
          </div>

          {skills.length > 9 && (
            <div
              className="skills-card__more"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded
                ? "Show Less ▲"
                : `+ ${skills.length - 9} more ▼`}
            </div>
          )}
        </Card.Body>
      </Card>

      <SkillsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
}

export default SkillsCard;